import React from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons';

import Modal from 'antd/lib/modal'

const DeleteModal = ({open, confirm, cancel}) => {
    const [loading, setLoading] = React.useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        await confirm();
        setLoading(false);
        cancel();
    }

    return (
        <Modal 
            open={open}
            title={<p><ExclamationCircleOutlined /> Eliminar</p>}
            onOk={handleConfirm}
            okText="Confirmar"
            onCancel={cancel}
            cancelText="Cancelar"
            confirmLoading={loading}
        >
            <p>Esta accion no es reversible. Una vez eliminado no podra recuperar el elemento</p>
            <b>¿Seguro que desea continuar?</b>
        </Modal>
    )
}

export default DeleteModal